
import {
  RECORDING_SERVICE_STATUS
} from '../../constants/constants';
/**
 * Class representing  audio record using Record JS library.
 * */
class AudioRecordJsService {

  audioContext = null;

  input = null;

  gumStream = null;

  rec = null;

  /**
   * Access device audio microphone, create stream, initializing Recorder.js and start recording
   * @return {object} Promise - The start record promise.
   * */
  startRecording = () => {
    const constraints = {
      audio: true,
      video: false
    };
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    this.audioContext = new AudioContext();

    return new Promise((resolve, reject) => {
      navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
        /* assign to gumStream for later use */
        this.gumStream = stream;
        this.input = this.audioContext.createMediaStreamSource(stream);
        this.rec = new Recorder(this.input, { numChannels: 1 });// eslint-disable-line no-undef
        this.rec.record();
        resolve(RECORDING_SERVICE_STATUS.STARTED);
      }).catch(() => {
        reject(RECORDING_SERVICE_STATUS.ERROR);
      });
    });

  }

  /**
   * Pause recording stream or resume it, depending on current recording state
   * @return {object} Promise - The pause record promise.
   * */
  pauseRecording = () => new Promise((resolve, reject) => {
    try {
      if (this.rec.recording) {
        this.rec.stop();
      } else {
        this.rec.record();
      }
      resolve(RECORDING_SERVICE_STATUS.PAUSED);
    } catch (error) {
      reject(RECORDING_SERVICE_STATUS.ERROR);
    }
  });

  /**
   * Stop recording and microphone.Return audio record as bulb in callback function
   * @param {function} callback - The callback function when file bulb is ready.
   * @return {object} Promise - The stop record promise.
   * */
  stopRecording = callback => new Promise((resolve, reject) => {
    try {
      this.rec.stop();
      this.gumStream.getAudioTracks()[0].stop();
      this.rec.exportWAV(callback);
      resolve(RECORDING_SERVICE_STATUS.STOPPED);
    } catch (error) {
      reject(RECORDING_SERVICE_STATUS.ERROR);
    }
  })
}

export default new AudioRecordJsService();



// WEBPACK FOOTER //
// ./src/common/services/audio-recordJs.service.js